export const STAFF_NOTES_MAX_LENGTH = 1000;
